import { useEffect, useState } from "react";
import ReactQuill from "react-quill";

// Read-only Manufacturer Order Details (mirrors ManageWOs layout without CRUD)
export default function MODetails({ selectedWO }) {
  /*   All States
   ********************************************* */
  const [contactInfo, setContactInfo] = useState({});
  const [billingAddress, setBillingAddress] = useState({});
  const [shippingAddress, setShippingAddress] = useState({});

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
      ["clean"],
    ],
  };

  /*   All Functions
   ********************************************* */

  const getContactInfo = (wo) => {
    let _contactInfo = wo?.WorkOrder?.contactData;
    let contactInfo =
      typeof _contactInfo === "string"
        ? JSON.parse(_contactInfo)
        : _contactInfo;

    setContactInfo(contactInfo);
  };

  const getBillingAddress = (wo) => {
    let _billingAddress = wo?.WorkOrder?.billingAddress;
    let billingAddress =
      typeof _billingAddress === "string"
        ? JSON.parse(_billingAddress)
        : _billingAddress;

    setBillingAddress(billingAddress);
  };

  const getShippingAddress = (wo) => {
    let _shippingAddress = wo?.WorkOrder?.shippingAddress;
    let shippingAddress =
      typeof _shippingAddress === "string"
        ? JSON.parse(_shippingAddress)
        : _shippingAddress;

    setShippingAddress(shippingAddress);
  };

  const getDate = (inputDate) => {
    const date = new Date(inputDate);
    if (isNaN(date.getTime())) {
      return null; // Invalid date
    }
    return date?.toISOString().slice(0, 10).replace("T", " ");
  };

  const getTransitDaysFromShipping = (shipping) => {
    let shippingAddress =
      typeof shipping === "string" ? JSON.parse(shipping) : shipping;
    return shippingAddress?.addressGroundTransitDays || "--";
  };

  /*   All UseEffects
   ********************************************* */

  useEffect(() => {
    console.log(selectedWO);
    if (selectedWO) {
      getContactInfo(selectedWO);
      getBillingAddress(selectedWO);
      getShippingAddress(selectedWO);
    }
  }, [selectedWO]);

  return (
    <div className="">
      {/* WO Basic Info */}
      <div className="bg-white shadow-sm custom-border-radius-sm px-3 py-3">
        <div className="d-flex align-items-center gap-3">
          {/* WoId */}
          <div>
            <span className="fw-bold ">WoId</span> :{" "}
            {selectedWO?.WorkOrder?.woId || "--"}
          </div>
          {/* Job Name */}
          <div>
            <span className="fw-bold ">Job Name</span> :{" "}
            {selectedWO?.WorkOrder?.jobName || "--"}
          </div>
          {/* Needed By */}
          <div>
            <span className="fw-bold ">Needed By</span> :{" "}
            {getDate(selectedWO?.WorkOrder?.WODate) || "--"}
          </div>
          {/*  Transit Days */}
          <div>
            <span className="fw-bold "> Transit Days</span> :{" "}
            {getTransitDaysFromShipping(
              selectedWO?.WorkOrder?.shippingAddress
            ) || "--"}
          </div>
          {/*  Ship Date */}
          <div>
            <span className="fw-bold "> Ship Date</span> :{" "}
            {selectedWO?.WorkOrder?.WoShipDate || "--"}
          </div>
        </div>
        <div className="d-flex align-items-center mt-2 gap-3">
          <div>
            <span className="fw-bold">First Name</span> :{" "}
            {contactInfo?.firstName || "--"}
          </div>
          <div>
            <span className="fw-bold">Last Name</span> :{" "}
            {contactInfo?.lastName || "--"}
          </div>
          <div>
            <span className="fw-bold">Department</span> :{" "}
            {contactInfo?.department || "--"}
          </div>
          <div>
            <span className="fw-bold">Phone</span> :{" "}
            {contactInfo?.phone || "--"}
          </div>
          <div>
            <span className="fw-bold">Email</span> :{" "}
            {contactInfo?.email || "--"}
          </div>
        </div>
      </div>
      {/* Billing Address & WO Details */}
      <div className="d-flex align-items-center my-2 gap-2">
        <div
          className="w-50 bg-white custom-border-sm py-2 px-3"
          style={{
            height: "230px",
          }}
        >
          <div>
            <h4 className="border-bottom">Billing Address</h4>
            {/* Description */}
            <div className="row">
              <div className="col-md-6">Description</div>
              <div className="col-md-6">
                {billingAddress?.description || "--"}
              </div>
            </div>
            {/* company */}
            <div className="row">
              <div className="col-md-6">Company</div>
              <div className="col-md-6">
                {billingAddress?.addressCompany || "--"}
              </div>
            </div>
            {/* Address 1 */}
            <div className="row">
              <div className="col-md-6">Address 1</div>
              <div className="col-md-6">
                {billingAddress?.addressLine1 || "--"}
              </div>
            </div>
            {/* Address 2 */}
            <div className="row">
              <div className="col-md-6">Address 2</div>
              <div className="col-md-6">
                {billingAddress?.addressLine2 || "--"}
              </div>
            </div>
            {/* City - State - Zip */}
            <div className="row">
              <div className="col-md-6">City-State-Zip</div>
              <div className="col-md-6">
                {billingAddress?.city || "--"} - {billingAddress?.state || "--"}{" "}
                - {billingAddress?.zip || "--"}
              </div>
            </div>
            {/* Country 2 */}
            <div className="row">
              <div className="col-md-6">Country</div>
              <div className="col-md-6">{billingAddress?.country || "--"}</div>
            </div>
          </div>
        </div>
        <div
          style={{
            height: "230px",
          }}
          className="w-50 bg-white custom-border-sm py-2 px-3"
        >
          <div className="">
            <h4 className="border-bottom">WO Details</h4>
            {/* Location */}
            <div className="row">
              <div className="col-md-6">Location</div>
              <div className="col-md-6">
                {selectedWO?.WorkOrder?.location?.name || "--"}
              </div>
            </div>
            {/* Wo Date */}
            <div className="row">
              <div className="col-md-6">Wo Date</div>
              <div className="col-md-6">
                {getDate(selectedWO?.WorkOrder?.WODate) || "--"}
              </div>
            </div>
            {/* Due Date */}
            <div className="row">
              <div className="col-md-6">Due Date</div>
              <div className="col-md-6">
                {getDate(selectedWO?.WorkOrder?.WoDueDate) || "--"}
              </div>
            </div>
            {/* Tax Rate */}
            <div className="row">
              <div className="col-md-6">Tax Rate</div>
              <div className="col-md-6">
                {selectedWO?.WorkOrder?.taxrate?.name || "--"}
              </div>
            </div>
            {/* Payment Terms */}
            <div className="row">
              <div className="col-md-6">Payment Terms</div>
              <div className="col-md-6">
                {selectedWO?.WorkOrder?.paymentTerm?.name || "--"}
              </div>
            </div>
            {/* Sales Person */}
            <div className="row">
              <div className="col-md-6">Sales Person</div>
              <div className="col-md-6">
                {selectedWO?.WorkOrder?.salesPerson?.name || "--"}
              </div>
            </div>
            {/* Shipping Method */}
            <div className="row">
              <div className="col-md-6">Shipping Method</div>
              <div className="col-md-6">
                {selectedWO?.WorkOrder?.shippingMethod?.name || "--"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex align-items-center my-2 gap-2">
        <div
          className="w-50 bg-white custom-border-sm py-2 px-3"
          style={{
            height: "350px",
          }}
        >
          <div>
            <h4 className="border-bottom">Shipping Address</h4>
            {/* Description */}
            <div className="row">
              <div className="col-md-6">Description</div>
              <div className="col-md-6">
                {shippingAddress?.description || "--"}
              </div>
            </div>
            {/* company */}
            <div className="row">
              <div className="col-md-6">Company</div>
              <div className="col-md-6">
                {shippingAddress?.addressCompany || "--"}
              </div>
            </div>
            {/* Address 1 */}
            <div className="row">
              <div className="col-md-6">Address 1</div>
              <div className="col-md-6">
                {shippingAddress?.addressLine1 || "--"}
              </div>
            </div>
            {/* Address 2 */}
            <div className="row">
              <div className="col-md-6">Address 2</div>
              <div className="col-md-6">
                {shippingAddress?.addressLine2 || "--"}
              </div>
            </div>
            {/* City - State - Zip */}
            <div className="row">
              <div className="col-md-6">City-State-Zip</div>
              <div className="col-md-6">
                {shippingAddress?.city || "--"} -{" "}
                {shippingAddress?.state || "--"} -{" "}
                {shippingAddress?.zip || "--"}
              </div>
            </div>
            {/* Country 2 */}
            <div className="row">
              <div className="col-md-6">Country</div>
              <div className="col-md-6">{shippingAddress?.country || "--"}</div>
            </div>
          </div>
          {/* Transit Days */}
          <div className="row">
            <div className="col-md-6">Transit Days</div>
            <div className="col-md-6">
              {shippingAddress?.addressGroundTransitDays || "--"}
            </div>
          </div>
        </div>
        <div
          className="w-50 bg-white custom-border-sm py-2 px-3"
          style={{
            height: "350px",
          }}
        >
          <h4 className="border-bottom">Wo Notes</h4>
          <div className="" style={{ height: "250px", overflow: "auto" }}>
            <ReactQuill
              modules={modules}
              theme="snow"
              value={selectedWO?.WorkOrder?.notes || ""}
              // onChange={setNotes}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
